import {
    ACCOUNT_SEARCHES_QUERY_KEY,
    REMOVE_SAVED_SEARCH_WEBHOOK_MUTATION_KEY,
    SAVE_SAVED_SEARCH_WEBHOOK_MUTATION_KEY,
    SAVED_SEARCH_WEBHOOKS_QUERY_KEY,
    TEST_SAVED_SEARCH_WEBHOOK_MUTATION_KEY,
} from "./const";

export const savedSearchWebhooksQueryKeys = {
    list: (): readonly string[] => [SAVED_SEARCH_WEBHOOKS_QUERY_KEY],
    accountSearches: (): readonly string[] => [ACCOUNT_SEARCHES_QUERY_KEY],
    save: (): readonly string[] => [SAVE_SAVED_SEARCH_WEBHOOK_MUTATION_KEY],
    remove: (): readonly string[] => [REMOVE_SAVED_SEARCH_WEBHOOK_MUTATION_KEY],
    test: (): readonly string[] => [TEST_SAVED_SEARCH_WEBHOOK_MUTATION_KEY],
};
